/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import get from "lodash/get";
import { PropTypes } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { CommentWidget } from "../../comment-widget";
import "./commenting-widget.module.css";

export class CommentingWidgetComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showComments: false
    };
    this.toggleComments = this.toggleComments.bind(this);
  }

  toggleComments(event) {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ showComments: !this.state.showComments });
  }

  commentsButton(text) {
    return (
      <div styleName="show-comments">
        <button onClick={this.toggleComments} styleName="show-comments-btn">
          {text}
        </button>
      </div>
    );
  }

  commentsWithButton() {
    return (
      <>
        {!this.state.showComments && this.commentsButton("Show Comments")}
        {this.state.showComments && <CommentWidget story={this.props.story} />}
        {this.state.showComments && this.commentsButton("Hide Comments")}
      </>
    );
  }

  render() {
    const showHideComments = get(this.props.pbConfig, ["general", "facebook", "hideComments"], this.props.hideComments);
    return showHideComments ? this.commentsWithButton() : <CommentWidget story={this.props.story} />;
  }
}

function mapStateToProps(state) {
  return {
    hideComments: get(state, ["qt", "config", "theme-attributes", "comment-plugin", "hideComments"], false),
    pbConfig: get(state, ["qt", "config", "pagebuilder-config"], {})
  };
}

CommentingWidgetComponent.propTypes = {
  hideComments: PropTypes.bool,
  story: PropTypes.object,
  pbConfig: PropTypes.object
};

export const CommentingWidget = connect(mapStateToProps)(CommentingWidgetComponent);
